import React, { useEffect, useState } from "react";

import { useNavigate, Link } from "react-router-dom";

import { MdSchedule } from "react-icons/md";
import { GiFactory } from "react-icons/gi";
import { BsPersonFill } from "react-icons/bs";
import { MdGroups } from "react-icons/md";
import { BsGraphUp } from "react-icons/bs";
import { BsCardChecklist } from "react-icons/bs";
import { BsPeople } from "react-icons/bs";
import { FaWarehouse } from "react-icons/fa";
import { BsBoxSeam } from "react-icons/bs";
import { MdListAlt } from "react-icons/md";
import { MdQrCodeScanner } from "react-icons/md";
import { BsTruck } from "react-icons/bs";
import { BsHouseDoorFill } from "react-icons/bs";
import { FcCollapse } from "react-icons/fc";
import { FcExpand } from "react-icons/fc";
import {RiArrowUpSLine,RiArrowDownSLine} from "react-icons/ri"
import { useDispatch, useSelector } from "react-redux";
import { setmainSection, setUserPermissions } from "../../redux/slices/user/userSlice";
import {getAuthorization} from "../../axios/AxiosAut";

type propss = {
  showSideBar: Boolean;
};
export default function ManagementListItem(props: propss) {
  const navigate = useNavigate();
  const [collaps, setcollaps] = React.useState(true);
  const [isInitialRender, setIsInitialRender] = useState(true);

  const Permissions = useSelector((state) => state.user.userPermissions);
  const viewcustomer = Array.isArray(Permissions) ? Permissions?.find((o) => o.codename === "view_customer"):[]
  const viewstaffAndgroups = Array.isArray(Permissions) ? Permissions?.find(
    (o) => o.codename === "view_customgroups"
  ):[]
  const viewitems = Array.isArray(Permissions) ? Permissions?.find((o) => o.codename === "view_products") : [];
  const viewsupplier = Array.isArray(Permissions) ? Permissions?.find((o) => o.codename === "view_supplier") : [];
  const viewPicking = Array.isArray(Permissions) ? Permissions?.find((o) => o.codename === "view_picking") : [];
  const viewwarehouse =  Array.isArray(Permissions) ? Permissions?.find((o) => o.codename === "view_warehouse") : [];
  const viewjobschedule = Array.isArray(Permissions) ? Permissions?.find((o) => o.codename === "view_jobschedule") : [];
  const viewgoodsinout = Array.isArray(Permissions) ? Permissions?.find((o) => o.codename === "view_goodsinout") : [];


  const dispatch = useDispatch();

  console.log("viewcustomer", viewcustomer);
  console.log("viewstaffAndgroups", viewstaffAndgroups);
  console.log("viewitems", viewitems);
  console.log("viewsupplier", viewsupplier);

  const mainSection = useSelector((state) => state.user.mainSection);

  console.log("mainSection in Start", mainSection);

  const updateState = () => {
    const newState = mainSection.map((obj) => {
      if (viewstaffAndgroups === undefined && obj.title === "Staff & Groups") {
        return { ...obj, permission: false };
      }
      if (viewcustomer === undefined && obj.title === "Customer") {
        return { ...obj, permission: false };
      }
      if (viewitems === undefined && obj.title === "Items") {
        return { ...obj, permission: false };
      }
      if (viewsupplier === undefined && obj.title === "Supplier") {
        return { ...obj, permission: false };
      }
      if (viewPicking === undefined && obj.title === "Picking & Packing") {
        return { ...obj, permission: false };
      }
      if (viewwarehouse === undefined && obj.title === "Warehouse") {
        return { ...obj, permission: false };
      }
      if (viewjobschedule === undefined && obj.title === "Schedule") {
        return { ...obj, permission: false };
      }
      if (viewgoodsinout === undefined && obj.title === "Goods in/out") {
        return { ...obj, permission: false };
      }
      // 👇️ otherwise return object as is
      return obj;
    });
    console.log("newstate......", newState);
    setIsInitialRender(false);
    dispatch(setmainSection(newState));
  };

  
  useEffect(() => {
    if (isInitialRender) {
    updateState();
    console.log("Permissions Updated");
    }
  }, [viewstaffAndgroups, viewsupplier, viewitems, viewcustomer, viewPicking,viewwarehouse,viewjobschedule, viewgoodsinout,isInitialRender]);

  const handlecollaps = () => {
    setcollaps(!collaps);
  };
  const handleRoute = () => {
    navigate("/production/schedule");
  };

  return (
    <>
      {props.showSideBar ? (
        <div>
          <div className="flex  px-2 mt-4 ">
            <div className="w-full">
              <div className="flex justify-between w-full items-center">
                <Link
                  to="/dashboard/management/management-dashboard"
                  className="flex justify-start items-center align-middle"
                >
                  <svg
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.7917 7.29271C19.7917 11.3187 16.5271 14.5844 12.5 14.5844C8.47292 14.5844 5.20833 11.3187 5.20833 7.29271C5.20833 3.26458 8.47292 0 12.5 0C16.5271 0 19.7917 3.26458 19.7917 7.29271ZM18.1271 14.7719C16.5583 15.9562 14.6125 16.6677 12.5 16.6677C10.3854 16.6677 8.43854 15.9542 6.86771 14.7698C2.62604 16.6375 0 22.4531 0 25H25C25 22.476 22.2917 16.6604 18.1271 14.7719Z"
                      fill="white"
                    />
                  </svg>

                  <h2 className="px-2 py-2 text-white font-Roboto">
                    Management
                  </h2>
                </Link>
                <button onClick={handlecollaps}>
                  {collaps ? (
                    <RiArrowUpSLine color="#FFFFFF" size={20} fill="white" />
                  ) : (
                    <RiArrowDownSLine color="#FFFFFF" size={20} fill="white" />
                  )}
                </button>
              </div>
            </div>
          </div>
          {collaps && (
            <ul className="ml-6 mr-6">
              {mainSection.map((item) => (
                item.permission === true ? ( <li className="p-1  rounded-md">
                <Link to={item.path}>
                  <div className="flex justify-start items-center align-middle hover:bg-blue-100 rounded-md pl-2">
                    {item.icon}
                    <h2 className="px-2 py-2 text-white font-Roboto">
                      {item.title}
                    </h2>
                  </div>
                </Link>
              </li>):null  
              ))}
            </ul>
          )}
        </div>
      ) : (
        <div className="pt-6">
          <div className="flex flex-col  px-2 item-center ">
            <button onClick={handlecollaps}>
              <BsPersonFill size="2rem" color="#FFFFFF" />
            </button>
          </div>
          {collaps && (
            <ul className="flex flex-col items-center py-2">
              {mainSection.map((item) => (
                   item.permission === true ?(  <li className="p-1 hover:bg-blue-100 rounded-md py-2">
                   <Link to={item.path}>{item.icon}</Link>
                 </li>): null
              ))}
            </ul>
          )}
        </div>
      )}
    </>
  );
}
